/**
 * @module-isolated analytics-lab
 * Tracker operativo (estilo LeadTrack) — mock de columnas + gaps honestos.
 * No escribe ni redefine Reservas / Leads oficiales.
 */
import { Link } from 'react-router-dom';
import { PageHeader, SectionHeader } from '../../../shared/components/index.js';
import LabBanner from '../components/LabBanner.jsx';

const COLUMNS = [
  {
    id: 'asistio',
    label: 'Asistió',
    gi: 'Sin campo canónico (Reuniones = Sin datos asistencia)',
    status: 'gap'
  },
  {
    id: 'seguimiento',
    label: 'Seguimiento',
    gi: 'Parcial vía Kommo / Sales Analytics (no ✓/✗ inline)',
    status: 'partial'
  },
  {
    id: 'reserva',
    label: 'Reserva',
    gi: 'Sheet Reservas (módulo oficial /reservas) — no flag en fila de lead',
    status: 'partial'
  },
  {
    id: 'compro',
    label: 'Compró / $',
    gi: 'Venta no definida en Analytics (N/D en Resumen)',
    status: 'gap'
  }
];

export default function LabTrackerPage() {
  return (
    <div className="analytics-module lab-module">
      <LabBanner pageLabel="Tracker operativo" />
      <PageHeader
        eyebrow="Lab · evaluar UX LeadTrack"
        title="Tracker operativo"
        subtitle="Maqueta de la tabla Asistió → Seguimiento → Reserva → Compró. No captura datos todavía; no altera módulos oficiales."
      />

      <section className="analytics-section">
        <SectionHeader
          title="Qué haría LeadTrack aquí"
          note="En LT los ✓/✗ se guardan solos y alimentan asistencia / cierre."
        />
        <div className="analytics-panel">
          <div className="lab-tracker-table-wrap">
            <table className="lab-tracker-table">
              <thead>
                <tr>
                  <th>Lead (ejemplo)</th>
                  <th>Asistió</th>
                  <th>Seguimiento</th>
                  <th>Reserva</th>
                  <th>Compró</th>
                  <th>$ Vendido</th>
                </tr>
              </thead>
              <tbody>
                <tr className="is-disabled">
                  <td colSpan={6}>
                    Sin captura operativa GI. Esta fila es placeholder: no hay API Lab que
                    escriba estos flags. Usá Kommo / sheets oficiales hasta definir fuente.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="analytics-section">
        <SectionHeader title="Estado por columna vs GI" />
        <div className="analytics-panel">
          <ul className="lab-gap-list">
            {COLUMNS.map((c) => (
              <li key={c.id}>
                <span className={'lab-chip is-' + c.status}>{c.status}</span>
                <strong>{c.label}</strong>
                <span className="lab-muted"> — {c.gi}</span>
              </li>
            ))}
          </ul>
          <p className="lab-muted">
            Módulos oficiales relacionados:{' '}
            <Link to="/old/reuniones">Reuniones</Link>
            {' · '}
            <Link to="/old/reservas">Reservas</Link>
            {' · '}
            <Link to="/">Leads</Link>
            {' · '}
            <Link to="/lab/definiciones">Comparar definiciones</Link>
          </p>
        </div>
      </section>
    </div>
  );
}
